export default "__VITE_ASSET___LS65r6___"